// ManageSettings.jsx
import React, { useState } from 'react';
import { FaMoon, FaSun, FaSyncAlt, FaUserEdit, FaKey, FaInfoCircle } from 'react-icons/fa';
import { useTheme } from '../theme/ThemeProvider';

const ManageSettings = () => {
  const { isDark, toggle, setTheme } = useTheme(); // <-- use global theme
  const [adminName, setAdminName] = useState('Admin');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleReset = () => {
    setTheme('light'); // resets to light
    setAdminName('Admin');
    setPassword('');
    setConfirmPassword('');
    alert('Settings reset to default!');
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-poppins text-driveeasy-blue2  mb-6">Manage Settings</h2>

      {/* Profile Update */}
      <div className="bg-white dark:bg-neutral-800 p-4 rounded shadow mb-6">
        <div className="flex items-center gap-2 mb-3 text-driveeasy-blue2  font-semibold">
          <FaUserEdit />
          <span>Update Admin Profile</span>
        </div>
        <input
          type="text"
          value={adminName}
          onChange={(e) => setAdminName(e.target.value)}
          className="p-2 border rounded w-full mb-3 bg-white dark:bg-neutral-700 dark:text-gray-100 dark:border-neutral-700"
        />
        <button
          onClick={() => alert('Profile Updated (not connected to backend)')}
          className="bg-driveeasy-blue text-white px-4 py-2 rounded hover:bg-driveeasy-yellow hover:text-black transition"
        >
          Save Profile
        </button>
      </div>

      {/* Change Password */}
      <div className="bg-white dark:bg-neutral-800 p-4 rounded shadow mb-6">
        <div className="flex items-center gap-2 mb-3 text-driveeasy-blue2  font-semibold">
          <FaKey />
          <span>Change Password</span>
        </div>
        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="p-2 border rounded w-full mb-2 bg-white dark:bg-neutral-700 dark:text-gray-100 dark:border-neutral-700"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="p-2 border rounded w-full mb-3 bg-white dark:bg-neutral-700 dark:text-gray-100 dark:border-neutral-700"
        />
        <button
          onClick={() => {
            if (password !== confirmPassword) return alert('Passwords do not match!');
            alert('Password Changed (not connected to backend)');
          }}
          className="bg-driveeasy-blue text-white px-4 py-2 rounded hover:bg-driveeasy-yellow hover:text-black transition"
        >
          Update Password
        </button>
      </div>

      {/* Dark Mode Toggle */}
      <div className="bg-white dark:bg-neutral-800 p-4 rounded shadow mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-driveeasy-blue2  font-semibold">
            {isDark ? <FaMoon /> : <FaSun />}
            <span>{isDark ? 'Dark Mode Enabled' : 'Light Mode Enabled'}</span>
          </div>
          <button
            onClick={toggle}
            className="px-4 py-2 bg-gray-100 dark:bg-neutral-700 dark:text-gray-100 rounded hover:bg-gray-200 dark:hover:bg-neutral-700"
          >
            Toggle Mode
          </button>
        </div>
      </div>

      {/* Reset / Clear */}
      <div className="bg-white dark:bg-neutral-800 p-4 rounded shadow mb-6">
        <div className="flex items-center gap-2 mb-3 text-driveeasy-blue2  font-semibold">
          <FaSyncAlt />
          <span>Reset Settings</span>
        </div>
        <button
          onClick={handleReset}
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
        >
          Clear / Reset All
        </button>
      </div>

      {/* Version Info */}
      <div className="bg-white dark:bg-neutral-800 p-4 rounded shadow">
        <div className="flex items-center gap-2 mb-3 text-driveeasy-blue2  font-semibold">
          <FaInfoCircle />
          <span>App Info</span>
        </div>
        <p><strong>Version:</strong> 1.0.0</p>
        <p><strong>Last Updated:</strong> August 2025</p>
      </div>
    </div>
  );
};

export default ManageSettings;
